export const stagmAndTallew = {
  id: "stagmAndTallew",
  link: "/#/recipes/recipes/stagmAndTallew",
  name: "Stagm and Tallew",
  cuisine: "Alethi Men's Food",
  summary: "Gravy over rice, served with celery root on the side",
  inspiration: null,
  quantity: "4 servings",
  time: "1 hour 15 minutes",
  notes:
    "The gravy and rice portion of the recipe was fairly straightforward. The question was the stagm. It's described as a brownish tuber that is small enough for an entire tuber to be a single serving, and it can be sliced into disks that can be picked up and topped with other food. (The Way of Kings ch 54) The closest I could find to this was celeriac (celery root). If your celeriac is too large for a single serving, feel free to use 2 large roots instead of 4 small ones, and to cut them in half once cooked.",
  quotes:
    "His food arrived, steamed stagm—a brownish tuber that grew in deep puddles—atop a bed of boiled tallew. The grain was puffed with water, and the entire meal was drenched in a thick, peppery, brown gravy. (The Way of Kings ch 54)",
  image:
    "https://jozomby-public.s3.amazonaws.com/recipes/stagm-tallew-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "celeriac",
          display: "4 medium-to-small celeriac (celery roots)"
        },
        {
          item: "rice",
          display: "2 cups basmati rice"
        },
        {
          item: "coconut",
          display: "1/4 cup coconut oil"
        },
        {
          item: "onion",
          display: "2 onions"
        },
        {
          item: "garamMasala",
          display: "1/2 tsp garam masala"
        },
        {
          item: "cumin",
          display: "1/2 tsp ground cumin"
        },
        {
          item: "cardamom",
          display: "1/4 tsp ground cardamom"
        },
        {
          item: "gochugaru",
          display: "2 tbsp gochugaru"
        },
        {
          item: "salt",
          display: "1 tsp salt"
        },
        {
          item: "garlicClove",
          display: "4 cloves garlic, minced"
        },
        {
          item: "water",
          display:
            "2 2/3 cup water, with additional for cooking rice and celeriac"
        },
        {
          item: "corn",
          display: "1/4 cup corn starch"
        }
      ]
    }
  ],
  steps: [
    "Peel the celeriac. Boil 1 hour or until a fork slides all the way in easily.",
    "Melt coconut oil in a pan over low heat. Dice the onions and them to pan along with the salt. Cook on low heat until golden, 45 to 60 minutes.",
    "Meanwhile, cook the basmati rice in a rice cooker, with the amount of water directed on the package",
    "Once the onions are browned, add the garam masala, cumin, cardamom, gochugaru, and minced garlic. Cook and stir over medium high heat for 2 minutes",
    "Add 2 cups water. Bring to a boil over medium high heat. In a bowl or cup, combine 2/3 cup water and corn starch to make a slurry. Pour the slurry into the pan, whisking as you do so. Cook and stir until thickened.",
    "Serve gravy over rice, with celeriac on the side. To eat, slice disks off the celeriac and pile with rice and gravy."
  ]
}
